import { Link } from "react-router-dom";
import { Youtube, Facebook, Mail } from "lucide-react";
import { SOCIAL, BOOK } from "@/data/book";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21l-6.51 7.44L22 22h-6.797l-4.86-6.36L4.6 22H2l6.97-7.96L1.5 2H8.4l4.41 5.83L18.244 2zm-1.19 18.5h1.84L7.06 3.42H5.1l11.954 17.08z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-secondary text-secondary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <p className="font-ui text-[11px] uppercase tracking-[0.3em] opacity-80">A Field Guide</p>
          <p className="font-display text-4xl mt-3 leading-none">{BOOK.brand}</p>
          <p className="font-body mt-4 opacity-90 max-w-sm leading-relaxed">
            New ways to see your mind. New ways to live with it. Letters, essays and quiet practices —
            sent only when there is something worth saying.
          </p>
        </div>

        <div>
          <p className="font-ui text-xs uppercase tracking-[0.25em] opacity-80 mb-4">Read</p>
          <ul className="space-y-2 font-ui text-sm">
            <li><Link to="/" className="link-soft opacity-90 hover:opacity-100">Home</Link></li>
            <li><Link to="/read" className="link-soft opacity-90 hover:opacity-100">The Book</Link></li>
            <li><Link to="/contact" className="link-soft opacity-90 hover:opacity-100">Contact</Link></li>
            <li><Link to="/admin" className="link-soft opacity-70 hover:opacity-100">Admin</Link></li>
          </ul>
        </div>

        <div data-testid="footer-social-links">
          <p className="font-ui text-xs uppercase tracking-[0.25em] opacity-80 mb-4">Pass it on</p>
          <div className="flex items-center gap-3">
            <a href={SOCIAL.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube"
               className="h-11 w-11 rounded-full border border-secondary-foreground/30 inline-flex items-center justify-center hover:bg-secondary-foreground hover:text-secondary transition-colors">
              <Youtube className="h-4 w-4" />
            </a>
            <a href={SOCIAL.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook"
               className="h-11 w-11 rounded-full border border-secondary-foreground/30 inline-flex items-center justify-center hover:bg-secondary-foreground hover:text-secondary transition-colors">
              <Facebook className="h-4 w-4" />
            </a>
            <a href={SOCIAL.twitter} target="_blank" rel="noreferrer" data-testid="footer-twitter"
               className="h-11 w-11 rounded-full border border-secondary-foreground/30 inline-flex items-center justify-center hover:bg-secondary-foreground hover:text-secondary transition-colors">
              <XIcon className="h-4 w-4" />
            </a>
            <a href={`mailto:${SOCIAL.email}`} data-testid="footer-email"
               className="h-11 w-11 rounded-full border border-secondary-foreground/30 inline-flex items-center justify-center hover:bg-secondary-foreground hover:text-secondary transition-colors">
              <Mail className="h-4 w-4" />
            </a>
          </div>
          <p className="font-ui text-xs mt-6 opacity-80">{SOCIAL.email}</p>
        </div>
      </div>
      <div className="border-t border-secondary-foreground/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 font-ui text-xs opacity-75">
          <p>© {new Date().getFullYear()} NewWaysToday — Professor KnowOne. All rights reserved.</p>
          <p className="italic">Take what serves your growth. Leave the rest for another season.</p>
        </div>
      </div>
    </footer>
  );
}
